import { render, staticRenderFns } from "./EditUtilisateurDroits.vue?vue&type=template&id=4a8cf1c6&"
import script from "./EditUtilisateurDroits.vue?vue&type=script&lang=ts&"
export * from "./EditUtilisateurDroits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports